export const MODEL_LABELS = {
  "gpt-5.5": "Senzai 5.5",
  "gpt-5.4": "Senzai 5.4",
  "gpt-5.4-mini": "Senzai 5.4 Mini",
  "gpt-5": "Senzai 5",
  "gpt-4o": "Senzai 4o",
  "gpt-4.1-mini": "Senzai 4.1 Mini",
};

// Map any raw model id (e.g. "gpt-5.4-mini") to its white-labeled Senzai name.
// Falls back to a generic "Senzai" prefix so a raw "gpt-*" id is never shown.
export const modelLabel = (id) => {
  if (!id) return "—";
  if (MODEL_LABELS[id]) return MODEL_LABELS[id];
  return "Senzai " + String(id).replace(/^gpt-?/i, "").trim();
};
